// extracted by mini-css-extract-plugin
module.exports = {"rightBlock":"rightBlock--gp3N6"};